import type { Locale } from '@skytech/types'
import { DEFAULT_LOCALE, getLocalDateTime } from '@skytech/utils'

import { useProfile } from '@/hooks/user'

export const useLocalDateTime = () => {
  const profile = useProfile()

  const formatTime = ({ date, locale }: { date: string | Date | null; locale?: Locale }) =>
    getLocalDateTime({
      date,
      locale: locale || profile?.locale || DEFAULT_LOCALE,
    })

  return { formatTime }
}
